import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogFooter,
  } from "@/components/ui/dialog";
  import { Button } from "@/components/ui/button";
  import { useState } from "react";
import { cancelSubscription } from "../services/admin-services";
import toastService from "@/services/toastService";
import { useNavigate } from "react-router-dom";
  
  interface ConfirmDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    onConfirm: () => Promise<void> | void;
    title?: string;
    description?: string;
    confirmText?: string;
    cancelText?: string;
    loadingText?: string;
    email?: string;
  }
  
  const ConfirmDialog = ({
    open,
    onOpenChange,
    onConfirm,
    title,
    description,
    confirmText = "Confirm",
    cancelText = "Cancel",
    loadingText = "Processing...",
    email,
  }: ConfirmDialogProps) => {
    const [isLoading, setIsLoading] = useState(false);
      const navigate = useNavigate();
  
    const handleConfirm = async () => {
      try {
        setIsLoading(true);
        const response =await cancelSubscription(email);
        if(response?.statusCode === 200) {
            toastService.success("Subscription cancelled successfully");
            navigate("/admin/dashboard/all-users");

            } 
        await onConfirm();
      } finally {
        setIsLoading(false);
        onOpenChange(false);
      }
    };
  
    return (
      <Dialog open={open} onOpenChange={(val) => !isLoading && onOpenChange(val)}>
        <DialogContent>
          <DialogHeader>
            {title && <DialogTitle>{title}</DialogTitle>}
            {description && <DialogDescription>{description}</DialogDescription>}
          </DialogHeader>
  
          <DialogFooter className="flex justify-end gap-4">
            <Button
              variant="secondary"
              size="sm"
              disabled={isLoading}
              onClick={() => onOpenChange(false)}
            >
              {cancelText}
            </Button>
            <Button
              className="!bg-charcoal !text-white font-medium"
              variant="outline"
              size="sm"
              disabled={isLoading}
              onClick={handleConfirm}
            >
              {isLoading ? loadingText : confirmText}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  };
  
  export default ConfirmDialog;
  